// ja — 日本語. Keys mirror zh-Hant.js.

export default {
  'app.title':           'Finance',
  'app.loading':         '読込中...',
  'nav.dashboard':       'ダッシュボード',
  'nav.transactions':    '取引',
  'nav.budgets':         '予算',
  'nav.settings':        '設定',
  'bottomnav.aria':      'メインナビゲーション',
  'sidebar.aria':        'デスクトップナビゲーション',

  'topbar.theme':        'テーマ切替',

  'dashboard.title':     'ダッシュボード',
  'dashboard.income':    '収入',
  'dashboard.expense':   '支出',
  'dashboard.net':       '純額',
  'dashboard.networth': '純資産',
  'dashboard.networthHelper': '総収入 − 総支出（全期間）',
  'dashboard.networthPositive': '黒字',
  'dashboard.networthNegative': '赤字',
  'dashboard.savings':   '貯蓄率',
  'dashboard.balance':   '残高',
  'dashboard.vsLast':    '前月比',
  'kpi.noComparison': '前期データなし',
  'dashboard.rangeLabel': '期間',
  'dashboard.rangeHint': 'クリックで当期間にジャンプ · 長押し/右クリックで日/月/年/5年を切り替え',
  'dashboard.vsYesterday':'昨日',
  'dashboard.vsLastYear':'対比去年',
  'dashboard.range.day': '日',
  'dashboard.range.month':'月',
  'dashboard.range.year':'年',
  'dashboard.range.5y': '5年',
  'dashboard.prevPeriod':'前の期間',
  'dashboard.nextPeriod':'次の期間',
  'dashboard.allCats':   'すべて',
  'dashboard.autoApplied':'定期取引 {n} 件を自動記録しました',
  'dashboard.forecast.title': '今後 30 日キャッシュフロー予測',
  'dashboard.forecast.subtitle': '定期取引ルールに基づく、来月の残高推移予測',
  'dashboard.forecast.todayBalance': '本日の残高',
  'dashboard.forecast.projection30d': '+30 日予測',
  'dashboard.forecast.delta': '本日比',
  'dashboard.forecast.activeCount': '有効ルール {n} 件',
  'dashboard.forecast.income': '収入',
  'dashboard.forecast.expense': '支出',
  'dashboard.forecast.legend.balance': '予測残高',
  'dashboard.forecast.legend.events': '収入 / 支出イベント',
  'dashboard.forecast.empty.title': '予測はまだありません',
  'dashboard.forecast.empty.body': '定期取引を設定すると、今後 30 日間のキャッシュフロー予測が表示されます。',
  'dashboard.forecast.empty.cta': '定期取引を設定 →',
  'dashboard.forecast.tooltip.balance': '残高',
  'dashboard.forecast.tooltip.events': '{n} 件のイベント',

  'tx.title':            '取引',
  'transactions.openFilters': 'フィルター',
  'transactions.filters': 'フィルター',
  'transactions.filterDrawerTitle': '取引をフィルター',
  'transactions.typeLabel': '種類',
  'transactions.categoryLabel': 'カテゴリー',
  'transactions.searchLabel': '検索',
  'transactions.removeFilter': 'フィルターを削除：{name}',
  'transactions.resetFilters': 'リセット',
  'transactions.applyFilters': '適用',
  'transactions.cardsTitle': 'クレジットカード',
  'transactions.cardFilterActive': 'フィルター中',
  'transactions.filterByCard': '{name} の取引のみ表示',
  'transactions.unfilterCard': 'すべてのカードを表示（フィルター解除）',
  'transactions.noCardMatch': 'この期間にこのカードでの取引はありません',
  'tx.search':           'メモ・カテゴリを検索',
  'tx.empty':            '取引はまだありません',
  'tx.emptyHint':        '下のボタンで追加',
  'tx.thisMonth':        '今月',
  'tx.lastMonth':        '先月',
  'tx.last30':           '過去30日',
  'tx.ytd':              '今年',
  'tx.all':              'すべて',
  'tx.expense':          '支出',
  'tx.income':           '収入',
  'tx.allPeriod':        '全期間',
  'tx.allCats':          'すべてのカテゴリ',
  'tx.tagLabel':         'タグ:',
  'tx.edit':             '編集',
  'tx.delete':           '削除',
  'tx.deleteConfirm':    'この取引を削除しますか?',
  'tx.bulkSelected':     '{n} 件選択中',
  'tx.bulkCancel':       'キャンセル',
  'tx.bulkSelectAll':    'すべて選択',
  'tx.bulkClear':        '選択解除',
  'tx.bulkDeleteConfirm':'選択した {n} 件の取引を削除しますか?',
  'tx.bulkDeleted':      '{n} 件の取引を削除しました',
  // Phase 111: recurring badge
  'tx.recurring':        '定期',

  'add.newTitle':        '新しい取引',
  'add.editTitle':       '取引を編集',
  'add.expense':         '支出',
  'add.income':          '収入',
  'add.amount':          '金額',
  'add.category':        'カテゴリ',
  'add.date':            '日付',
  'add.note':            'メモ',
  'add.notePlaceholder': '任意',
  // Phase 80: mode-toggle buttons inside the add modal.
  'add.modeAdd':         '追加',
  'add.modeTransfer':    '振替',
  // Phase 80: single merged payment-method picker.
  'add.paymentMethod':   '支払方法',
  'add.tags':            'タグ',
  'add.tagsPlaceholder': 'カンマ区切り',
  'add.card':            'クレジットカード',
  'add.cardNone':        'なし',
  'add.today':           '今日',
  // Phase 203: quick date chips in the Add Transaction form.
  'add.yesterday':       '昨日',
  'add.dayBefore':       '一昨日',
  // Phase 186 (M-113): 詳細設定アコーディオン(tag/note/bulk を畳む)。
  'add.advanced':        '詳細設定',
  // Phase 189 (M-116): pager 制御(前/次ページ矢印 + ドットインジケータ)。
  'addCategoryPager.prev': '前のページ',
  'addCategoryPager.next': '次のページ',
  'addCategoryPager.pageIndicator': '{n}/{total} ページ',
  // Phase 189 (M-116): AddCategoryModal ドロワー labels。
  'addCategory.title':          '新規カテゴリー',
  'addCategory.newCategory':    '＋ 新規カテゴリー',
  'addCategory.nameLabel':      '名前',
  'addCategory.namePlaceholder':'例：コーヒー基金',
  'addCategory.iconLabel':      'アイコン',
  'addCategory.colorLabel':     'カラー',
  // Phase 49: bulk apply to date range
  'bulk.applyToRange':   '日付範囲で適用',
  'bulk.endDate':        '終了日',
  'bulk.dayOfWeek':      '曜日',
  'bulk.weekdayShort':   ['日', '月', '火', '水', '木', '金', '土'],
  'bulk.presetWeekdays': '平日 (月〜金)',
  'bulk.presetEveryDay': '毎日',
  'bulk.presetMWF':      '月/水/金',
  'bulk.preview':        '{count} 件の取引を追加',
  'bulk.emptyRange':     '該当の日付がありません',
  'add.cancel':          'キャンセル',
  'add.save':            '保存',
  'add.saved':           '保存しました',
  'add.failed':          '保存失敗: {msg}',

  'budgets.title':       '予算',
  'budgets.empty':       '予算は未設定です',
  'budgets.emptyHint':   'カテゴリの「上限を設定」から保存できます',
  'budgets.setLimit':    '上限を設定',
  'budgets.used':        '使用済み',
  'budgets.of':          '/',
  'budgets.overBudget':  '予算オーバー!',
  'budgets.heroTotal':   '今月の総予算',
  'budgets.heroRemaining': '残り {amount}',
  'budgets.heroOverBy':  '{amount} 超過',
  'budgets.heroNoBudgets': '今月はまだ予算が未設定です',
  'budgets.heroNoBudgetsHint': 'カテゴリに上限を設定すると追跡を開始します',
  'budgets.heroPctAria': '今月の総予算使用率 {pct}',

  // ─── Savings Goals (Phase 48) ────────────────────────────────────────
  'goals.title':                  '貯金目標',
  'goals.widgetTitle':            '貯金目標 ({n})',
  'goals.widgetEmpty':            '目標を設定して進捗を確認しましょう',
  'goals.summary':                '目標サマリー',
  'goals.summaryPctAria':         '全体の進捗 {pct}',
  'goals.empty':                  '貯金目標がまだありません',
  'goals.emptyHint':              '目標を設定して貯金の進捗を追跡しましょう',
  'goals.addGoal':                '目標を追加',
  'goals.editGoal':               '目標を編集',
  'goals.deleteGoal':             '目標を削除',
  'goals.deleteConfirm':          '目標「{name}」を削除しますか?',
  'goals.field.name':             '目標名',
  'goals.field.target':           '目標金額',
  'goals.field.current':          '現在の貯金額',
  'goals.field.deadline':         '目標期日',
  'goals.field.trackingFrom':     '開始日',
  'goals.field.icon':             'アイコン',
  'goals.field.color':            '色',
  'goals.field.allocationPct':    '月次配分 (%)',
  'goals.field.active':           '有効',
  'goals.paused':                 '一時停止',
  'goals.activeOn':               '有効',
  'goals.activeOff':              '停止中',
  'goals.pctSumUnder':           '現在合計 {sum}% (< 100 OK, 余りは追跡外)',
  'goals.pctSumOver':            '現在合計 {sum}% (> 100 は保存不可)',
  'goals.allocationHint':         '毎月 {pct}% · あと {months} ヶ月',
  'goals.mode.auto':              '自動',
  'goals.mode.manual':            '手動',
  'goals.eta':                    'あと {days} 日で達成見込み',
  'goals.etaMonths':              'あと {months} ヶ月で達成見込み',
  'goals.etaDate':                '{date} 達成見込み',
  'goals.etaNoHistory':           '—',
  'goals.completed':              '達成済み',
  'goals.completedOver':          '目標超過 +{amount}',
  'goals.progressAria':           '{name} {pct} 貯金',
  'goals.overrides':              '前借金額',
  'goals.section':                '貯金目標 ({count})',  'accounts.title': '口座・財布',
  'transfer.title': '振替',
  'accounts.widgetTotal': '全口座合計',
  'accounts.widgetEmpty': '口座がまだありません',
  'chart.viewAsChart': 'グラフ表示',
  'chart.close': 'グラフを閉じる',
  'transfer.mode': '振替モード',
  'transfer.from': '振替元',
  'transfer.to': '振替先',
  'transfer.sameAccount': '元口座と先口座は異なる必要があります',
  'transfer.success': '振替を記録しました',
  'transfer.filter': '振替のみ表示',
  'transfer.tag': 'transfer',
  // Phase 203: specific transfer validation errors. Before, every
  // failure showed 'transfer.sameAccount' — so "pick a destination
  // account" was reported as "source and destination must differ".
  'transfer.errMissingFrom':     '振替元の口座を選択してください',
  'transfer.errMissingTo':       '振替先の口座を選択してください',
  'transfer.errInvalidAmount':   '0より大きい金額を入力してください',
  'transfer.errAccountMissing':  'その口座は存在しません',
  'transfer.noAccountsHint':     '振替を記録する前に、設定で口座を追加してください',
  'accounts.label': '口座',
  'accounts.add': '口座を追加',
  'accounts.all': 'すべての口座',
  'accounts.defaultName': '現金',


  'settings.title':      '設定',
  'settings.subnavLabel': '設定セクション',
  'settings.subnavCurrency': '通貨',
  'settings.subnavCards': 'カード',
  'settings.subnavRecurring': '定期',
  'settings.subnavCategories': 'カテゴリー',
  'settings.subnavGoals': '目標',
  'settings.subnavData': 'データ',
  'settings.subnavAbout': 'について',
  'settings.section.cash':           '現金',
  'settings.section.cards':          'クレジットカード ({n})',
  'settings.section.recurring':      '毎月の定期収入/支出 ({n})',
  'settings.section.expenseCats':    '支出カテゴリ ({n})',
  'settings.section.incomeCats':     '収入カテゴリ ({n})',
  'settings.section.sync':           'Google 同期',
  'settings.section.data':           'データ',
  'settings.section.currency':       '通貨',
  'settings.section.appearance':     '外観',
  'settings.section.about':          '情報',
  'settings.section.language':       '言語',

  'settings.language.label':     '表示言語',
  'settings.language.help':      '即時に切り替わります。',

  'settings.appearance.dark':    'ダークモード',
  'settings.appearance.compact': 'コンパクト表示',

  'settings.about.storage':      '保存先: ローカル SQLite ({path})',
  'settings.about.localOnly':    'すべてのデータはお使いの端末のみ。クラウドには送信されません。',
  'settings.about.title':        '情報',
  'settings.cardName':           'カード名',
  'settings.cardNamePlaceholder': '例: HSBCプラチナ',
  'settings.dueDay':             '支払日',
  'settings.outstandingAmount':  '未払金額',
  'settings.symbolExists':       'この記号はすでに存在します',
  'settings.addSymbolFailed':    '記号の追加に失敗しました: {msg}',
  'settings.removeSymbolConfirm':'記号「{symbol}」を削除しますか?',
  'settings.keepOneSymbol':      '記号を1つ以上残してください',
  'settings.removeSymbolFailed': '記号の削除に失敗しました: {msg}',

  'settings.recurring.add':      '追加',
  'settings.recurring.edit':     '編集',
  'settings.recurring.delete':   '削除',
  'settings.recurring.monthly':  '毎月 {n} 日',
  'settings.recurring.addTitle': '新しい定期ルール',
  'settings.recurring.editTitle':'定期ルールを編集',
  'settings.recurring.type':     'タイプ',
  'settings.recurring.category': 'カテゴリ',
  'settings.recurring.amount':   '金額',
  'settings.recurring.day':      '毎月の日',
  'settings.recurring.dayPlaceholder': '例: 1 (毎月1日)',
  'settings.recurring.note':     'メモ',
  'settings.recurring.notePlaceholder': '例: 月給',
  'settings.recurring.from':     '開始月',
  'settings.recurring.to':       '終了月（任意）',
  'settings.recurring.autoApplied': '📌 定期取引 {n} 件を自動記録しました:\n{lines}',
  'settings.recurring.cancel':   'キャンセル',
  'settings.recurring.save':     '保存',
  'settings.recurring.deleteConfirm': 'この定期ルールを削除しますか?',
  'settings.recurring.amountPlaceholder': '例: 30000',
  'settings.recurring.fromPlaceholder': '開始月',
  'settings.recurring.toPlaceholder': '終了日なし',
  'settings.recurring.period':   '{from} → {to}',

  'settings.category.name':      '名前',
  'settings.category.type':      'タイプ',
  'settings.category.icon':      'アイコン',
  'settings.category.color':     '色',
  'settings.category.addNew':    '新しいカテゴリ',
  'settings.category.editOne':   'カテゴリを編集',
  'settings.category.cancel':    'キャンセル',
  'settings.category.save':      '保存',
  'settings.category.nameRequired':'名前を入力してください',
  'settings.category.deleteConfirm':'カテゴリ「{name}」を削除しますか?',
  'settings.category.namePlaceholder': '例: サブスク',
  'settings.category.expense': '支出',
  'settings.category.income': '収入',
  'settings.category.colorAria': '色 {color}',
  // Phase 79f: defaults have a small badge + enable/disable toggle.
  'settings.category.defaultBadge': 'デフォルト',
  'settings.category.defaultHint':  'デフォルトカテゴリは編集・削除できません — 有効化/無効化のみ',
  'settings.category.enable':       '有効化',
  'settings.category.disable':      '無効化',

  'common.back':         '戻る',
  'common.cancel':       'キャンセル',
  'common.save':         '保存',
  'common.search':       '検索',
  'common.delete':       '削除',
  'common.confirmDelete':'削除を確認しますか?',
  'common.edit':         '編集',
  'common.confirm':      '確認',
  'common.close':        '閉じる',
  'common.failed':       '保存失敗: {msg}',
  'common.failedDelete': '削除失敗: {msg}',
  'common.deleteConfirm':'本当に削除しますか?',
  'common.today':        '今日',
  'common.unknown':      '名称未設定',
  'common.optional':     '任意',
  'common.none':         'なし',

  'err.generic':         'エラーが発生しました: {msg}',

  'signin.title':        'Google アカウント連携',
  'signin.subtitle':     '端末と Google Drive 間でデータを同期します',
  'signin.button':       'Google でログイン',
  'signin.skip':         'あとで (ローカル利用)',
  'signin.connected':    '接続済み',
  'signin.disconnect':   'ログアウト',

  'cmd.placeholder':     'コマンド・ページ・取引を検索...',
  'cmd.section.pages':   'ページ',
  'cmd.section.actions': 'コマンド',
  'cmd.section.recent':  '最近の取引',
  'cmd.theme.toggle':    'テーマ切替',
  'cmd.theme.dark':      'ダークモード',
  'cmd.theme.light':     'ライトモード',
  'cmd.lang.switch':     '言語切替',
  'cmd.shortcutHint':    '⌘K / Ctrl K で検索を開く',

  'placeholder.noData':  'データなし',
  'placeholder.addFirst':'最初のを追加',

  'dashboard.refresh.refreshing': '⟳ 更新中…',
  'dashboard.refresh.release': '↓ 離して更新',
  'dashboard.kpi.incomeYear': '収入(年)',
  'dashboard.kpi.incomeDay': '収入(今日)',
  'dashboard.kpi.income5y': '収入(5年)',
  'dashboard.kpi.expenseYear': '支出(年)',
  'dashboard.kpi.expenseDay': '支出(今日)',
  'dashboard.kpi.expense5y': '支出(5年)',
  'dashboard.kpi.netYear': '純額(年)',
  'dashboard.kpi.netDay': '純額(今日)',
  'dashboard.kpi.net5y': '純額(5年)',
  'dashboard.rangeLabel.year': '全年 12 ヶ月',
  'dashboard.rangeLabel.week': '過去 7 日',
  'dashboard.rangeLabel.halfYear': '過去 6 ヶ月',
  'dashboard.rangeLabel.fiveYear': '過去 5 年（60 ヶ月）',
  'dashboard.filter.title': 'フィルター',
  'dashboard.filter.openFilters': 'フィルター',
  'dashboard.filter.typeLabel': '種別',
  'dashboard.filter.categoriesLabel': 'カテゴリー',
  'dashboard.filter.amountLabel': '金額範囲',
  'dashboard.filter.amountMin': '最小',
  'dashboard.filter.amountMax': '最大',
  'dashboard.trend.yoyLabel': '対比 {ym}',
  'dashboard.trend.yoyIncome': '収入(前年)',
  'dashboard.trend.yoyExpense': '支出(前年)',
  'dashboard.trend.viewLabel': 'トレンド表示',
  'dashboard.trend.viewTimeline': '時系列',
  'dashboard.trend.viewByYear': '年別比較',
  'dashboard.trend.metricLabel': '指標',
  'dashboard.onlyShowing': '{name} のみ表示',
  'dashboard.autoAppliedFmt': '📌 定期取引 {n} 件を自動記録しました',
  'dashboard.card.dueTodayTitle': '💳 {name} 本日期限',
  'dashboard.card.dueInDaysTitle': '💳 {name} {n} 日後に期限',
  'dashboard.card.unpaidHint': '{amount} 未払い · 引き落としをお忘れなく',
  'dashboard.card.graceSuffix': '(あと {n} 日猶予)',
  'filter.all': 'すべて',
  'filter.thisMonth': '今月',
  'filter.lastMonth': '先月',
  'filter.thisYear': '今年',
  'filter.date': '日付',
  'filter.amount': '金額',
  'filter.sortByDate': '日付順',
  'filter.sortByAmount': '金額順',
  'filter.noMatches': '該当期間に取引がありません',
  'dashboard.card.overdue': '{n} 日超過 · {date}',
  'dashboard.card.paidOn': '{date} に支払い済み',
  'dashboard.card.allPaid': '今サイクルはすべて支払い済み',
  'dashboard.card.dueToday': '本日期限 · {date}',
  'dashboard.card.dueTomorrow': '明日期限 · {date}',
  'dashboard.card.dueInDaysFmt': '{n} 日後に期限 · {date}',
  'placeholder.empty': 'データなし',
  'common.loadingDots': '読み込み中…',
  'dashboard.filtering': '絞り込み: ',
  'common.clear': 'クリア',
  'dashboard.netWorthSummary': '収入 {income} · 支出 {expense}',
  'dashboard.categoryBreakdown': 'カテゴリ別内訳',
  'common.manage': '管理',
  'dashboard.cardReminder': 'カード支払いリマインダー',
  'dashboard.recentTransactions': '最近の取引',
  'budgets.alerts': '予算アラート',
  'tx.seeAll': 'すべて見る',
  'tx.prevMonth': '前の月',
  'tx.nextMonth': '次の月',
  'common.clearSearch': '検索をクリア',
  'tx.noSearchMatch': '「{q}」に一致する取引はありません',
  'add.dirtyConfirm': '未保存の変更を破棄しますか?',
  // Phase 106 (M-36): first-transaction celebration banner.
  'add.firstTxCelebration': '🎉 最初の記録完了!ようこそ',
  'common.saving': '保存中…',
  'add.noCardsHint': 'クレジットカードがまだありません。設定から追加してください。',
  'budgets.deleteConfirm': 'このカテゴリの予算上限をクリアしますか?',
  'budgets.clear': 'クリア',
  'budgets.description': '各カテゴリの月次上限を設定します。上限を超えるとダッシュボードが通知します。',
  'budgets.thisMonthUsage': '今月 {spent} / {limit}',
  'budgets.limitPlaceholder': '月次上限',
  'budgets.invalidAmount': '予算は正の数を指定してください',
  'settings.cardsTitle': 'クレジットカード ({count})',
  'settings.cardsEmpty': 'クレジットカードがまだありません。「+ 新規」で追加してください。',
  'settings.editCard': 'クレジットカードを編集',
  'settings.deleteCard': 'クレジットカードを削除',
  'settings.newCard': 'クレジットカードを追加',
  'settings.recurringTitle': '毎月の定期取引 ({count})',
  'settings.editRecurring': '定期取引を編集',
  'settings.deleteRecurring': '定期取引を削除',
  'settings.newRecurring': '定期取引を追加',
  'settings.expenseCatsTitle': '支出カテゴリ ({count})',
  'settings.incomeCatsTitle': '収入カテゴリ ({count})',
  'settings.newCategory': 'カテゴリを追加',
  'settings.editCategory': 'カテゴリを編集',
  'settings.deleteCategoryConfirm': 'カテゴリ「{name}」を削除しますか?',
  'settings.deleteRecurringConfirm': 'この定期取引を削除しますか?',
  'settings.deleteCardConfirm': 'このクレジットカードを削除しますか?',
  'signin.loadGoogleFailed': 'Google ログインを読み込めません: {msg}',
  'signin.tagline': 'Google アカウントでログイン。データはあなただけのものです。',
  'signin.googleNotConfigured': 'Google ログインが設定されていません (GOOGLE_CLIENT_ID が不足)',
  'signin.signingIn': 'ログイン中...',
  'cmd.newTx': '取引を追加',
  'cmd.goTo': '移動',
  'appearance.theme': 'テーマ',
  'appearance.light': 'ライト',
  'appearance.dark': 'ダーク',
  // Phase 81: replaced misleading "デフォルトはシステムに従います" hint.
  'appearance.themeHint': '選択後すぐに反映されます',
  'appearance.notifications': 'ブラウザ通知',
  'appearance.notifDenied': '通知権限が拒否されました。ブラウザ設定で有効にしてください。',
  'appearance.notifLabel': 'クレジットカードの猶予期間が危機的なときに通知',
  // Phase 81: removed dev-environment copy.
  'appearance.notifHint': 'ブラウザ通知権限が必要です。',
  'recap.title': '週間まとめ',
  'recap.expenseFmt': '今週の出費:{amount}',
  'recap.topCategoryFmt': 'トップ:{category} {amount}',
  'recap.upVsLastWeek': '先週より増',
  'recap.downVsLastWeek': '先週より減',
  'appearance.weeklyRecap': '週間まとめ通知',
  'appearance.weeklyRecapHint': '日曜日に今週の出費を通知します。',
  'appearance.compactFilter': 'コンパクト表示',
  'appearance.compactFilterHint': 'カテゴリチップを隠してヘッダーを節約',
  // Phase 81: distinct section heading (was duplicating the toggle label).
  'appearance.compactFilterTitle': '取引ページのフィルター',
  'installments.title': '分割払い',
  'installments.add': '分割払いを追加',
  'installments.empty': '分割払いはまだありません',
  'installments.total': '合計',
  'installments.monthlyAmount': '月額',
  'installments.periods': '{paid}/{total} 回支払い済み',
  'installments.remaining': '残り {n} 回',
  'installments.nextPayment': '次の支払い',
  'installments.complete': '完了',
  'installments.markPaid': '今回の支払いを完了',
  'installments.markEnded': '分割払いを完了',
  'installments.note': 'メモ (購入内容)',
  'installments.totalAmount': '合計金額',
  'installments.totalPeriods': '回数',
  'installments.startMonth': '開始月',
  'installments.card': 'クレジットカード',
  'installments.future.title': '今後の分割',
  'installments.future.subtitle': '{n} 回の未払い、合計 {total}',
  'installments.notify.title': '分割払いのお知らせ',
  'installments.notify.body': '{card} · {amount} · {period}/{total}回目{note_sfx}',
  'installments.notify.noteSuffix': ' ({note})',
  'currency.title': '通貨表示',
  'currency.saveFailed': '保存失敗: {msg}',
  'currency.addFailed': '追加失敗: {msg}',
  'currency.keepOne': '少なくとも 1 つの記号を残してください',
  'currency.deleteSym': '{sym} を削除',
  'currency.addAria': '新しい通貨記号を追加',
  'currency.preview': '現在の表示: {amount}',
  'data.title': 'データ管理',
  'data.importHint': 'CSV ファイルから取引をインポート',
  'data.importAria': 'CSV ファイルを選択',
  'data.importColumns': '列順: type, amount, category, occurred_on, note, tags',
  'data.importing': 'インポート中…',
  'data.importOk': '{imported} 件成功、{skipped} 件スキップ',
  'data.importOkErrors': ' · {n} 件エラー',
  'data.importFailed': 'インポート失敗: {msg}',
  'data.exportHint': 'すべての取引をCSVファイルとしてダウンロード',
  'data.exportBtn': 'CSV エクスポート',
  'data.exporting': 'エクスポート中…',
  'data.exportOk': '{n} 件の取引をエクスポートしました',
  'data.exportFailed': 'エクスポート失敗:{msg}',
  'data.clearHint': 'すべての取引を削除(カテゴリ・予算・設定は保持)',
  'data.clearAll': 'すべての取引を削除',
  'data.clearConfirm': 'すべての取引を削除しますか?この操作は取り消せません。',
  'data.clearing': '削除中…',
  'data.confirmClear': '削除を確認',
  'data.clearedN': '{n} 件の取引を削除しました',
  'data.clearFailed': '削除失敗:{msg}',
  // Phase 47: redesigned DataSection visual hierarchy
  'data.dangerZone': '危険ゾーン',
  'data.dangerZoneDesc': 'これらの操作は取り消せません。注意して使用してください。',
  'data.importDrop': 'クリックまたは CSV ファイルをここにドロップ',
  'data.importDropHint': '.csv 形式に対応',
  'account.title': 'アカウント連携',
  'account.subtitle': '取引を他の端末と同期します。',
  'account.noName': '(名前なし)',
  'account.signOutConfirm': 'ログアウトしますか?',
  'account.signOut': 'ログアウト',
  'account.saveFailed': '保存失敗:{msg}',
  // Phase 46: local-vs-cloud アカウント UI
  'account.localBadge': 'ローカルアカウント',
  'account.localDesc': 'この端末にのみ保存されます。バックアップ・同期はありません。',
  'account.deleteLocal': 'ローカルアカウントを削除',
  'account.deleteLocalConfirm': 'このローカルアカウントを削除しますか?この端末のすべてのデータが完全に消去されます。',
  'account.deleteLocalDone': 'ローカルアカウントを削除しました',
  'account.connectGoogle': 'Google アカウントと連携',
  'account.connectGoogleDesc': '取引を他の端末と同期します。',
  'account.googleComingSoon': '近日公開 — Phase B',
  'account.deleteLocalHint': 'この操作は取り消せません。',
  // Phase 46b: bullet-style local-account description + new keys
  'account.connected': '連携済み',
  'account.localBullet.device': 'この端末に保存',
  'account.localBullet.noBackup': 'バックアップなし',
  'account.localBullet.noSync': '同期なし',
  // Phase 40: developer card (local-only sample data)
  'developer.title': '開発者',
  'developer.version': 'App バージョン',
  'developer.localOnly': 'この端末の IndexedDB のみに書き込み、サーバーには送信されません。',
  'developer.seed500': 'サンプル取引を 500 件生成',
  'developer.seed100': 'サンプル取引を 100 件生成',
  'developer.seed10y': 'サンプル取引を 1200 件 / 10 年生成',
  'developer.seedConfirm': 'この端末に {n} 件のランダムなサンプル取引（{y} 年間に分散）を挿入しますか?',
  'developer.seedOk': '{n} 件のサンプル取引を挿入しました。',
  'developer.resetTx': 'この端末のすべての取引を削除',
  'developer.resetConfirm': 'この端末のすべての取引を削除しますか?この操作は元に戻せません。',
  'developer.resetOk': '{n} 件の取引を削除しました。',
  'developer.working': '処理中…',
  'developer.failed': '失敗: {msg}',
  'topbar.search': '検索',
  'topbar.searchTitle': '検索 (Cmd/Ctrl+K)',
  'topbar.themeLight': 'ライトに切り替え',
  'topbar.themeDark': 'ダークに切り替え',
  'topbar.quickAdd': '取引追加',
  'topbar.filters': 'フィルター切替',
  'topbar.searchTip': '/ または Cmd+K を押します',
  'fab.newTx': '取引を追加',
  'common.refresh.release': '↓ 離して更新',
  'common.refresh.refreshing': '⟳ 更新中…',
  'budgets.notSet': '予算が未設定',
  'budgets.notSetHint': '「予算」ページで月次上限を設定',
  'budgets.budgetsCount': '件の予算',
  'budgets.overCount': '件超過',
  'budgets.warnCount': '件近づく',
  'budgets.over': '超過',
  'budgets.warn': '近い',
  'budgets.progressAria': '{name} {pct} 使用',
  'tx.seeAllFmt': 'すべて見る ({count})',
  'tx.emptyCta': '取引を追加',
  'tx.listCountFmt': '{shown} / {total} 件を表示',
  'category.noExpense': '支出記録なし',
  'settings.categoryNameRequired': '名前を入力してください',
  'settings.reorderFailed': '並び替え失敗: {msg}',
  'settings.moveUp': '上に移動',
  'settings.moveDown': '下に移動',
  'settings.reorder': 'ドラッグして並べ替え',
  'settings.cardSettleConfirm': '支払い済みとして記録しますか?今期の累計は 0 にリセットされます。',
  'settings.cardSettleTitle': '支払い済みにして今期累計をリセット',
  'settings.cardSettleFailed': '支払い確認失敗: {msg}',
  'settings.cardStatementDue': '締め日 {stmt} · 支払日 {due}',

  'settings.cardDueToday': '本日支払期日',
  'settings.cardDueTomorrow': '明日支払期日',
  'settings.cardDueInDays': '{n} 日後支払期日',
  'settings.cardGraceRemaining': '残り {n} 日猶予期間',
  'settings.cardOverdue': '{n} 日超過',
  'settings.cardOutstanding': '今期累計 {amount}',
  'settings.cardSettle': '支払いを確認',

  'settings.cardPaid': '支払い済み',
  'settings.statementDay': '締め日',
  'settings.expiryMonth': '有効期限 月 (MM)',
  'settings.expiryYear': '有効期限 年 (YY)',
  'settings.expiryMonthPlaceholder': '例: 8',
  'settings.expiryYearPlaceholder': '例: 27',
  'settings.expiryHint': '任意。月と年は両方入力してください。',
  'settings.recurringHint': '設定後、ダッシュボードを開くたびに当月の取引が自動記録されます(現地時間)。',
  'settings.category.editorHint': '名前を入力し、種類、アイコン、色を選択します。',
  'signin.appTitle': '家計簿 App',
  'common.add': '追加',
  'common.all': 'すべて',
  'categories.餐飲': '飲食',
  'categories.交通': '交通',
  'categories.水費': '水道料金',
  'categories.電費': '電気料金',
  'categories.煤氣': 'ガス料金',
  'categories.居家': '住居',
  'categories.投資': '投資',
  'categories.娛樂': '娯楽',
  'categories.購物': '買い物',
  'categories.醫療': '医療',
  'categories.稅務': '税金',
  // Phase 82b: renamed from 交卡數 to 卡數.
  'categories.卡數': 'カード支払い',
  'categories.其他': 'その他',
  'categories.薪金': '給与',
  'categories.投資回報': '投資収益',
  'categories.獎金': 'ボーナス',
  'cmd.ariaLabel': 'コマンドパレット',
  'cmd.searchPlaceholder': '取引・カテゴリ・予算・定期・カードを検索...',
  'cmd.loading': '読み込み中…',
  'cmd.noResults': '「{q}」に一致する結果はありません',
  'cmd.footerHint': '↑↓ 選択 · ↵ 確定 · ESC 閉じる',
  'cmd.toOpen': 'で開く',
  'cmd.expenseCat': '支出カテゴリ',
  'cmd.incomeCat': '収入カテゴリ',
  'cmd.budget': '予算',
  'cmd.perMonth': '毎月',
  'cmd.dayOfMonth': '日',
  'cmd.outstanding': '未払い',
    'cardDetail.title': 'カード明細',
    'cardDetail.empty': 'このカードにはまだ取引がありません',
    'cardDetail.notFound': 'カードが見つかりません',
    'cardDetail.outstanding': '未払残高',
    'cardDetail.nextDue': '次回支払期日',
    'cardDetail.cycle': '請求サイクル',
    'cardDetail.markPaid': '本日支払済にする',
    'cardDetail.transactions': '取引履歴',
    'cardDetail.addTagged': '取引を追加',
    'cardDetail.openCard': '{name}の取引を表示',
    'cardDetail.paidOn':   '{date} に支払い済み',

    // Phase 102: First-time onboarding carousel.
    'onboard.step1.title':      '言語と通貨を設定',
    'onboard.step1.body':       'よく使う言語と通貨記号を選んでください。設定で後から変更できます。',
    'onboard.step1.langLabel':  '言語',
    'onboard.step1.curLabel':   '通貨記号',
    'onboard.step1.preview':    '現在の表示',
    'onboard.step2.title':      '最初の取引を記録',
    'onboard.step2.body':       '数秒で記録できます。後から追加・編集・削除が可能です。',
    'onboard.step2.bullet1':    '種類を選択(支出/収入)',
    'onboard.step2.bullet2':    '金額を入力しカテゴリを選ぶ',
    'onboard.step2.bullet3':    '保存するとすぐにホームに表示',
    'onboard.step2.tipNote':    'ヒント: 最初の追加時に 3 つのヒントが表示されます。「了解」で閉じられます。',
    'onboard.step3.title':      'ローカル優先 + クラウドバックアップ',
    'onboard.step3.body':       'データはこの端末に保存され、オフラインでも使用できます。Google にログインすると端末間で同期されます。',
    'onboard.step3.bullet1':    'ローカル保存: 高速、オフライン対応',
    'onboard.step3.bullet2':    'Google ログイン(任意): 端末間同期',
    'onboard.step3.signinNote': 'ログイン後、ローカルデータは自動的にクラウドにプッシュされます。',
    'onboard.back':             '戻る',
    'onboard.next':             '次へ',
    'onboard.skip':             'スキップ',
    'onboard.later':            'あとで',
    'onboard.logNow':           '今すぐ記録',
    'onboard.start':            '使い始める',
    'onboard.tooltip.type':     '👆 支出と収入を分けて記録すると、統計が見やすくなります。',
    'onboard.tooltip.amount':   '💰 クイックキーパッドで金額を入力できます。',
    'onboard.tooltip.category': '🏷️ カテゴリを選ぶと、後の傾向分析が楽になります。',
    'onboard.tooltip.gotIt':    '了解',
    'onboard.replay.title':     'チュートリアル',
    'onboard.replay.body':      '初回ガイドをもう一度表示します。',
    'onboard.replay.button':    'チュートリアルを再生',

    // Phase 104: collapsible group titles + privacy mode.
    'settings.group.prefs':    '環境設定 / Preferences',
    'settings.group.tracking': '記録 / Tracking',
    'settings.group.data':     'データ / Data',
    'settings.group.help':     'ヘルプ / Help',
    'privacy.title':           '金額を隠す',
    'privacy.body':            '有効にすると、ダッシュボード/取引/予算の金額が非表示になります。タップで5秒間表示されます。',

    // Phase 103: Reset All Settings (destructive).
    'resetAll.title':         'すべての設定を初期化',
    'resetAll.body':          '取引、口座、カテゴリ、予算、定期収支、カード、目標、分割、設定など、すべてのローカルデータを削除します。サーバー上のデータは保持されます。再読み込み後、初回チュートリアルが再表示されます。',
    'resetAll.button':        'すべての設定を初期化',
    'resetAll.confirmTitle':  'すべてのローカルデータを削除しますか?',
    'resetAll.confirmBody':   'この操作は元に戻せません。確認のため {phrase} と入力してください。',
    'resetAll.confirmLabel':  'DELETE と入力',
    'resetAll.confirmButton': '完全に削除',
    'resetAll.failed':        '初期化に失敗しました:{msg}',

    // Phase 202d/202e: Sync section + destructive server wipe.
    'settings.sync.title':                  'デバイス間同期',
    'settings.sync.desc':                   'Google アカウントからすべてのデータをこの端末に再取得します。新しい端末や再インストール後に使用します。',
    'settings.sync.button':                 '今すぐ同期',
    'settings.sync.wipeButton':             'この端末を消去して同期し直す',
    'settings.sync.wipeConfirmTitle':       'この端末の取引・カテゴリ・クレジットカード・定期・予算・目標・口座をすべて消去し、サーバーから再取得します。',
    'settings.sync.wipeConfirmWarn':        'サーバーに未アップロードの端末データは完全に失われます。先に「今すぐ同期」でサーバー上のデータを確認してください。',
    'settings.sync.wipeExecute':            '消去して同期し直す',
    'settings.sync.wipeServerButton':       'サーバーデータを消去して再ログイン',
    'settings.sync.wipeServerConfirmTitle': 'サーバー上のすべての取引・カテゴリ・クレジットカード・定期・予算・目標・設定・アカウントを完全に削除します。',
    'settings.sync.wipeServerConfirmWarn':  'サーバーデータは復元できません。完了後ページは再読み込みされ、Google アカウントでの再ログインが必要になります。',
    'settings.sync.wipeServerExecute':      'サーバーを消去する',
    'common.error':                         'エラーが発生しました',

  // Phase 208 / card 208-D1 — recurring-transaction reminders.
  'recurring.reminder.title': 'リマインダー',
  'recurring.reminder.countFmt': '近日予定の定期取引 {count} 件',
  'recurring.reminder.itemFmt': '{category} · {amount} · {when}',
  'recurring.reminder.dueToday': '本日到期',
  'recurring.reminder.dueInDays': '{n} 日後に到期',
  'recurring.reminder.appliedFmt': '{name} は自動登録されました',
  'recurring.reminder.toggleLabel': '記録する前に通知する',
  'recurring.reminder.leadLabel': '{n} 日前に通知する',
  'recurring.reminder.globalToggle': '定期取引のリマインダー',
  'recurring.reminder.globalHint': '次に app を開いたときに通知します(記録される前)。',
};
